// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2-2-2-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern22222DE: PageEntry = {
  id: "post.umweltpakt-bayern-2-2-2-2-2",
  locale: "de",
  slug: "umweltpakt-bayern-2-2-2-2-2",
  seo: {
    title: "Bautagebuch in bewegten Bildern | Dietz GmbH",
    description: "Bautagebuch in bewegten Bildern",
  },
  type: "post",
  h1: "Bautagebuch in bewegten Bildern",
  blocks: [
    { kind: "heading", level: 2, text: "Bautagebuch in bewegten Bildern" },
    { kind: "paragraph", text: "Mit dem neuen Verwaltungsgebäude hat DIETZ 2020 einen Meilenstein in Sachen Nachhaltigkeit gesetzt. Die gesamte Bauphase wurde in Zusammenarbeit von DIETZ und dem ausführenden Bauunternehmen GOLDBECK Ost GmbH in bewegten Bildern festgehalten:" }
  ],
};
